import { render } from "./LbrxKeyboard.vue?vue&type=template&id=a14fdef0&scoped=true"
import script from "./LbrxKeyboard.vue?vue&type=script&lang=js"
export * from "./LbrxKeyboard.vue?vue&type=script&lang=js"

import "./LbrxKeyboard.vue?vue&type=style&index=0&id=a14fdef0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a14fdef0"]])

export default __exports__